import { useEffect, useState } from "react";

// ! Make sure to keep the breakpoint list in sync with styles/tools/media-queries.scss
const breakpoints = {
  s: 320,
  m: 640,
  l: 1024,
  xl: 1344,
};

const mediaQueries = {
  s: `(min-width: 0) and (max-width: ${breakpoints.m - 1}px)`,
  m: `(min-width: ${breakpoints.m}px) and (max-width: ${breakpoints.l - 1}px)`,
  l: `(min-width: ${breakpoints.l}px) and (max-width: ${breakpoints.xl - 1}px)`,
  xl: `(min-width: ${breakpoints.xl}px)`,
};

export const mockMediaQueryList = {
  media: "",
  matches: false,
  onchange: () => {},
  addListener: () => {},
  removeListener: () => {},
  addEventListener: () => {},
  removeEventListener: () => {},
  dispatchEvent: () => true,
};

const matchMedia = (query) =>
  typeof window !== "undefined" &&
  typeof window.matchMedia !== "undefined" &&
  typeof MediaQueryList !== "undefined"
    ? window.matchMedia(query)
    : mockMediaQueryList;

const useMediaQuery = (query, defaultState = undefined) => {
  const [matches, setMatches] = useState(
    defaultState === undefined ? matchMedia(query).matches : defaultState
  );

  useEffect(() => {
    let mounted = true;

    const mediaQueryList = matchMedia(query);

    const onChange = () => {
      if (!mounted) {
        return;
      }

      setMatches(mediaQueryList.matches);
    };

    mediaQueryList.addListener(onChange);
    setMatches(mediaQueryList.matches);

    return () => {
      mounted = false;
      mediaQueryList.removeListener(onChange);
    };
  }, [query, typeof window]);

  return matches;
};

export { breakpoints, mediaQueries, useMediaQuery };
